import { render, staticRenderFns } from "./empresa.vue?vue&type=template&id=3e4e0407&"
import script from "./empresa.vue?vue&type=script&lang=js&"
export * from "./empresa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports